import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer } from '../data/content';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const offer = document.getElementById('oferta');
      if (!offer) {
        setVisible(false);
        return;
      }
      setVisible(offer.getBoundingClientRect().bottom <= window.innerHeight);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-197" data-mp="c6qs5pca3svg">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-line bg-night/95 px-4 py-3 backdrop-blur" data-id="element-198" data-mp="c5pdzbzyuq9i">
          <div className="mx-auto flex max-w-content items-center justify-between gap-4" data-id="element-199" data-mp="gvfc4m5o8p67">
            <div className="hidden sm:block" data-id="element-200" data-mp="c4yyb0xxv1jb">
              <p className="font-sans text-sm font-semibold text-parchment" data-id="element-201" data-mp="c471jmsluxrg">
                Botiquín Espiritual · 50 tarjetas + 4 bonos
              </p>
              <p className="font-sans text-xs text-parchment/55" data-id="element-202" data-mp="lv1zhof7rlsq">
                Hoy{' '}
                <span className="font-semibold text-gold-soft" data-id="element-203" data-mp="zujfpfeg1qqh">
                  {launchOffer.price} {launchOffer.currency}
                </span>{' '}
                · Garantía de 7 días
              </p>
            </div>
            <CtaButton size="block" href={checkoutUrl} className="sm:w-auto sm:px-8" data-id="element-204" data-mp="31lei4q35oo66">
              {cta.short}
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}